import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import client from "../client";
import handleApiError from "../../hooks/handleApiError";

export default function useFetchClassReportCard(session, term) {
  const { classId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const request = useCallback(
    async (_session, _term) => {
      setLoading(true);

      try {
        const res = await client.get(`/result/${classId}/reportcard`, {
          params: {
            session: _session,
            term: _term,
          },
        });

        if (res.data?.success) setData(res.data?.data);

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleApiError(error);
      }
    },
    [classId]
  );

  useEffect(() => {
    if (session && term) request(session, term);
  }, [request, session, term]);

  return { data, loading, request };
}
